import {styled} from '@mui/material/styles';

export const PageTitleActionAreaContainer = styled('div')(({theme}) => ({
    display: 'grid',
    gridArea: 'page-title-action-area-container',
    gridTemplateAreas: ' "page-title page-title-action-area" ',
    gridTemplateColumns: '1fr auto',
    width: '100%',
    marginBottom: theme.tokens.FuelSpacing3
}));
